/**
 * Почему закончился прошлый сеанс.
 *
 * Жалоба «меня выкинуло» неотличима снаружи от «я сам вышел» и от «сервер
 * отозвал сессию»: экран входа в любом случае один и тот же. Поэтому причина
 * записывается в момент выхода и показывается на экране входа — один случай
 * воспроизведения, и путь известен точно.
 *
 * Хранится рядом с сессией, но переживает её удаление: иначе запись пропадала
 * бы вместе с тем, что мы расследуем.
 */
const KEY = 'familychat.sessionEnd';

/**
 * Причина выхода. Строка, а не перечисление: в отказе сервера хочется видеть
 * ещё и код ответа, а он известен только в момент записи.
 */
export type SessionEndReason = string;

export interface SessionEnd {
  reason: SessionEndReason;
  at: string;
}

export function noteSessionEnd(reason: SessionEndReason): void {
  try {
    localStorage.setItem(KEY, JSON.stringify({ reason, at: new Date().toISOString() }));
  } catch {
    // Хранилище недоступно — расследование обойдётся, переписка важнее
  }
}

export function lastSessionEnd(): SessionEnd | null {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as SessionEnd) : null;
  } catch {
    return null;
  }
}

export function forgetSessionEnd(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // Не удалилось — покажется ещё раз, это не беда
  }
}
